import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import BlueFireworkPanel from '../../components/blueFireworkPanel';
import {pxToEm} from '../../components/globalStyles';
import PlayerNoteworthyFeatureData, {IPlayerNoteworthyFeature} from '../../data/playerNoteworthyFeatureData';
import {RootState} from '../../logic/store';
import {LoadingState, State as SalesDemosState} from '../../logic/store/salesDemosStore';

import NoteworthyFeature from './noteworthyFeature';

//#region Styled Components

const StyledBlueFireworkPanel = styled(BlueFireworkPanel)`
  color: white;
  border-radius: 8px;
`;

const featuresH2FontSizePx = 27;
const StyledFeaturesH2 = styled.h2`
  font-size: ${pxToEm(featuresH2FontSizePx)}em;
  width: 100%;
  text-align: center;
  margin-top: ${pxToEm(38) / pxToEm(featuresH2FontSizePx)}em;
  margin-bottom: ${pxToEm(53) / pxToEm(featuresH2FontSizePx)}em;
`;

const StyledFeaturesWrapperDiv = styled.div`
  padding-left: ${pxToEm(53)}em;
  padding-right: ${pxToEm(90)}em;
  padding-bottom: ${pxToEm(53)}em;
`;

const StyledNoteworthyFeature = styled(NoteworthyFeature)`
  align-items: center;

  :not(:last-child) {
    margin-bottom: ${pxToEm(42)}em;
  }
`;

//#endregion

interface MapStateToProps {
  salesDemos?: SalesDemosState;
}

interface Props extends MapStateToProps {
  className?: string;
}

class NoteworthyFeaturesSection extends React.Component<Props> {
  private findSalesDemoId = (feature: IPlayerNoteworthyFeature): string | undefined => {
    const {loadingState, response} = this.props.salesDemos;

    if (loadingState !== LoadingState.Success) {
      return undefined;
    }

    const allLoadedDemos = response.demos || [];
    const foundDemo = allLoadedDemos.find(salesDemo => salesDemo.path === feature.salesDemoPath);
    if (foundDemo === undefined) {
      return undefined;
    }

    return foundDemo.id;
  };

  public render() {
    return (
      <StyledBlueFireworkPanel
        fireworks={[{bottom: '-10%', right: '-25%', width: '120%'}]}
        className={this.props.className}>
        <StyledFeaturesH2>Noteworthy Features</StyledFeaturesH2>
        <StyledFeaturesWrapperDiv>
          {PlayerNoteworthyFeatureData.map((feature, index) => (
            <StyledNoteworthyFeature
              key={`player-noteworthy-feature-${index}`}
              feature={feature}
              salesDemoId={this.findSalesDemoId(feature)}
            />
          ))}
        </StyledFeaturesWrapperDiv>
      </StyledBlueFireworkPanel>
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  salesDemos: state.salesDemos
});

export default connect(mapStateToProps)(NoteworthyFeaturesSection);
